export default "__VITE_ASSET__TA5dTzg7__"